// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-QpA6r","btnDetail":"index-btnDetail-1E2Pi","active":"index-active-2lnSp"};